import classNames from 'clsx';
import React, { type PropsWithChildren, useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';

import { PAID_FEATURES_TOOLTIP_ID, PaidFeaturesTooltip } from './PaidFeaturesTooltip';
import styles from './PaidFeaturesWrapper.css';

interface PaidFeaturesWrapperProps {
    tooltipOuter: boolean;
    isOnboarding: boolean;
    isFolder: boolean;
}

export function PaidFeaturesWrapper({ children, tooltipOuter, isOnboarding, isFolder }: PropsWithChildren<PaidFeaturesWrapperProps>) {
    const ref = useRef<HTMLDivElement | null>(null);
    const tooltipShown = Boolean(useSelector((state) => UserStorageSelectors.get(state, PAID_FEATURES_TOOLTIP_ID)));
    const [withBorder, setWithBorder] = useState(false);
    const onTooltipShow = useCallback(() => {
        setWithBorder(true);
    }, []);
    const onTooltipClose = useCallback(() => {
        setWithBorder(false);
    }, []);

    return isOnboarding || !isFolder ? (
        <>{children}</>
    ) : (
        <div className={classNames(styles.root, { [styles.withBorder]: withBorder, [styles.intab]: tooltipOuter })}>
            <div className={classNames(styles.tooltipAnchor, { [styles.outer]: tooltipOuter })} ref={ref} />
            {children}
            <PaidFeaturesTooltip forcePromo={!tooltipShown} target={ref} onShow={onTooltipShow} onClose={onTooltipClose} />
        </div>
    );
}
